"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useNavigatorLanguage_1 = require("../use/useNavigatorLanguage");
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Menu_1 = __importDefault(require("@material-ui/core/Menu"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var styles_1 = require("@material-ui/styles");
var StyledMenu = styles_1.withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})(function (props) { return (react_1.default.createElement(Menu_1.default, __assign({ elevation: 0, getContentAnchorEl: null, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    } }, props))); });
var LanguageButton = function () {
    var _a = react_1.useContext(useNavigatorLanguage_1.LocaleContext), locale = _a[0], setLocale = _a[1];
    var optionsfindIndex = react_1.useMemo(function () { return useNavigatorLanguage_1.localeOptions
        .findIndex(function (option) { return option.language === locale; }); }, [locale]);
    var _b = react_1.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = react_1.useState(optionsfindIndex), selectedIndex = _c[0], setSelectedIndex = _c[1];
    function handleClickListItem(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleMenuItemClick(index, language) {
        setSelectedIndex(index);
        setAnchorEl(null);
        if (setLocale) {
            setLocale(language);
        }
    }
    function handleClose() {
        setAnchorEl(null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { "aria-controls": "menu", "aria-haspopup": "true", size: "large", color: "primary", onClick: handleClickListItem }, useNavigatorLanguage_1.localeOptions[selectedIndex] ? useNavigatorLanguage_1.localeOptions[selectedIndex].label : useNavigatorLanguage_1.localeOptions[1].label),
        react_1.default.createElement(StyledMenu, { anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, useNavigatorLanguage_1.localeOptions.map(function (option, index) { return (react_1.default.createElement(MenuItem_1.default, { key: option.language, color: "primary", selected: index === selectedIndex, onClick: function () { return handleMenuItemClick(index, option.language); } }, option.label)); }))));
};
exports.default = LanguageButton;
